import { useTranslation } from 'react-i18next'
import { NS } from '~/enums'

export const useFuturesPayoutTypeTranslations = () => {
  const { t } = useTranslation()
  const payoutTypesTranslationMappings: {
    [key: number]: {
      label: string
      description: string
    }
  } = {
    1: {
      label: t('classic', { ns: NS.CHALLENGES, defaultValue: 'Classic' }),
      description: t('classic_futures_program_description', {
        ns: NS.CHALLENGES,
        defaultValue:
          'Classic Futures focuses on performance, requiring traders to meet profit targets before receiving rewards and scaling up.',
      }),
    },
    2: {
      label: t('prime', { ns: NS.CHALLENGES, defaultValue: 'Prime' }),
      description: t('prime_futures_program_description', {
        ns: NS.CHALLENGES,
        defaultValue:
          'Prime Futures program offers traders greater consistency with fewer rules, lower costs, and flexible rewards.',
      }),
    },
  }

  return {
    payoutTypesTranslationMappings,
  }
}
